import CircularProgress from '@mui/material/CircularProgress';

export const ProgressIndicator = () => <CircularProgress size={36} />;
